module.exports = __webpack_public_path__ + "img/CPO.33c65ccc.png";